import { getValidToken, requireSessionToken } from '@avantstay/auth-token'

import { buildArriereAuthHeaders } from './arriere-headers'

export type GetEmail = () => string | null

export interface ArriereRequest {
  headers: Record<string, string>
  /** Set when the client retries; a previous 401 means the token was rejected and a new one is needed. */
  retry?: { previousResponse?: { status?: number } }
}

interface ArriereRequestListenerProps extends ArriereRequest {
  getEmail: GetEmail | null
  /** False for endpoints that also serve anonymous requests; those go out without a token. */
  requiresAuth: boolean
}

export const arriereRequestListener = async ({
  headers,
  retry,
  getEmail,
  requiresAuth,
}: ArriereRequestListenerProps) => {
  const tokenRequest = { skipCache: retry?.previousResponse?.status === 401 }
  const token = requiresAuth
    ? await requireSessionToken(tokenRequest)
    : await getValidToken(tokenRequest)
  if (!token) return

  Object.assign(headers, buildArriereAuthHeaders({ email: getEmail?.() ?? null, token }))
}
